import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLLIElement
  Blocks: {
    default: []
  }
  Args: {
    disabled?: boolean
  }
}

export const ActionMenuItem: TOC<Signature> = <template>
  <li
    aria-disabled={{if @disabled "true" "false"}}
    role="menuitem"
    class="text-dusty-black-500 hover:bg-dusty-black-50 focus:bg-dusty-black-50 aria-disabled:bg-dusty-black-50 aria-disabled:text-dusty-black-200 cursor-pointer px-5 py-2 whitespace-nowrap aria-disabled:pointer-events-none aria-disabled:cursor-default"
    ...attributes
  >
    {{yield}}
  </li>
</template>

export default ActionMenuItem
